export default __webpack_public_path__ + "static/media/goeppingen_light.81cfc37a.png";